import React from "react";
import { ReportsButton } from "./ReportsButton";

import SpecimensPerWeekGraph from "./SpecimensPerWeekGraph";
import {
  REPORT_GROUPS,
  listedReports,
} from "../../../ModalRouter/Reports/definitions";

const ICONS = { pie: "PieChartIcon", bar: "BarChartIcon", line: "ShowChartIcon", trend: "StackedLineChartIcon" };

// As many buttons to a row as fit, each as tall as its title needs.
const BUTTON_GRID = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
  gap: "10px",
  width: "100%",
};

export const Reports = ({ data, handleButtonClick }) => {
  const buttonsFor = (group) =>
    listedReports(group).map((d) => (
      <ReportsButton
        key={d.slug}
        handleButtonClick={handleButtonClick}
        buttonType={d.slug}
        title={d.shortTitle}
        icon={ICONS[d.icon] ?? null}
        comingSoon={Boolean(d.comingSoon)}
      />
    ));

  return (
    <div style={{ maxWidth: "95%" }}>
      <SpecimensPerWeekGraph data={data} />
      <div
        style={{
          textAlign: "center",
          justifyContent: "center",
          marginTop: "20px",
          color: "#167bc3",
          fontFamily: "Roboto",
        }}
      >
        {Object.entries(REPORT_GROUPS).map(([group, label]) => (
          <div
            key={group}
            style={{
              display: "flex",
              margin: "10px",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ marginBottom: "5px", fontWeight: "500", fontSize: "15px" }}>{label.toUpperCase()}</div>
            <div style={BUTTON_GRID}>{buttonsFor(group)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
